import ManagedReverseProxy from "../../../../contents/docs/advanced/proxy/_snippets/managed-reverse-proxy.mdx";
import * as React from 'react';
export default {
  ManagedReverseProxy,
  React
};